export const events = {
	chatOpened: "mem_rc_chat_opened",
	chatClosed: "mem_rc_chat_closed",
	redeemCodeSucceeded: "mem_rc_redeem_code_succeeded",
	redeemCodeFailed: "mem_rc_redeem_code_failed",
	findCodesSucceeded: "mem_rc_find_codes_succeeded",
	findCodesFailed: "mem_rc_find_codes_failed",
	resendCodesSucceeded: "mem_rc_resend_codes_succeeded",
	resendCodesFailed: "mem_rc_resend_codes_failed",
	contactSupportInitiated: "mem_rc_contact_support_initiated",
	accessContentInitiated: "mem_rc_access_content_initiated",
	examContextSwitchSucceeded: "mem_rc_exam_context_switch_succeeded",
	examContextSwitchFailed: "mem_rc_exam_context_switch_failed",
} as const;
